<template>
  <!-- <div> -->
  <div class="holy-beast-info" v-if="beasts.length>0">
    <div class="holy-beast-nav">
      <tx-btn
        :src="
          cur_key == b_index
            ? 'oldclassic_p_roleinfo_btn_ls_dis'
            : 'oldclassic_p_roleinfo_btn_ls_ovr'
        "
        v-for="(beast, b_index) in beasts"
        :key="b_index"
        @click="cur_key = b_index"
        :name="`灵兽-${beast['type_name']}`"
      >
        {{ beast['type_name'] }}
      </tx-btn>
    </div>

    <tx-bg src="oldclassic_p_roleinfo_img_ls_db" class="holy-beast-content">
      <tx-bg src="oldclassic_p_roleinfo_img_ls_db_1">
        <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian2">
          灵兽名
        </tx-bg>
        <div class="hourse-info">
          <img
            :src="`https://cbg-tx3.res.netease.com/images/role/hbs/${beast['hb_type']}.jpg`"
            width="146"
            height="160"
          />

          <tx-bg src="oldclassic_p_roleinfo_img_lsmz_db" class="middle m-t-8">
            {{ beast['type_name'] }}
          </tx-bg>
        </div>

        <div class="center">
          <tx-bg
            src="oldclassic_p_roleinfo_img_lsbiaoti_db"
            class="between m-t-16 c-golden"
          >
            <div class="middle width-p-50">技能名</div>
            <div class="middle width-p-50">技能境界</div>
          </tx-bg>

          <tx-bg
            src="oldclassic_p_roleinfo_img_lsms_db"
            v-for="(skill, s_index) in beast['skills']"
            :key="s_index"
            class="between m-t-8"
          >
            <div class="middle width-p-50">{{ skill['name'] }}</div>
            <div class="middle width-p-50">{{ skill['lv'] }}</div>
          </tx-bg>
        </div>
      </tx-bg>

      <tx-bg src="oldclassic_p_roleinfo_img_ls_db_2">
        <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian2">
          灵兽属性
        </tx-bg>
        <div class="column">
          <div class="p-lr-40">
            <t-row
              v-for="(item, i_margin1) in margin1"
              :key="i_margin1"
              :title="item.text"
              titleClass="t-title-ls"
              valueClass="roleinfo-attr-value row-value-bg"
              :value="beast[item.key]"
              class="m-tb-4"
            />
          </div>

          <div class="grid-2 p-lr-40">
            <template v-for="(item, i_margin2) in margin2" :key="i_margin2">
              <t-row
                :title="item.text"
                valueClass="roleinfo-attr-value row-value-bg"
                :value="beast[item.key]"
                class="m-tb-4"
              />

              <t-row
                title="资质"
                valueClass="roleinfo-attr-value row-value-bg"
                :value="beast['a_' + item.key]"
                class="m-tb-4"
              />
            </template>
          </div>

          <div class="p-lr-40 m-t-16">
            <t-row
              v-for="(item, i_margin3) in margin3"
              :key="i_margin3"
              :title="item.text"
              titleClass="t-title-ls"
              valueClass="roleinfo-attr-value row-value-bg"
              :value="beast[item.key]"
              class="m-tb-4"
            />
          </div>
        </div>
      </tx-bg>

      <tx-bg src="oldclassic_p_roleinfo_img_ls_db_3">
        <!-- <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian2">
          七曜星盘
        </tx-bg>

        <ul class="StarTables" v-if="false">
          <li v-for="(equ, e_index) in beasts_equ[cur_key]" :key="e_index">
            <commonItem
              :content="equ['content']"
              :title="`#c${equ['name_color']}${beast_star_names[e_index]}`"
              :class="`StarTable StarTable${e_index} HBStarBg${equ['inner_color']}`"
            />

            <div
              v-if="equ.is_active"
              :class="`StarTable StarTable${e_index} HBStarBgActive`"
            ></div>
          </li>

          <li>
            <div
              class="StarTable StarTable{{ e_index + beasts_equ[beast_equ_idx]|length }} {% if beast['lv'] < req_lv -%}HBStarBgUnreached{% else %}HBStarBgEmpty{% endif %}"
              tooltip_title="#W{{beast_star_names[i]}}"
              tooltip_intro="#R
                    {%- if beast['lv'] < req_lv -%}
                    {{- req_lv}}级开启此星点。
                    {%- else -%}
                    已开启星点，需要灵化。
                    {%- endif %}"
            ></div>
          </li>
        </ul>

        <div class="lingshou-box" v-if="false">


          <a
            href="javascript:;"
            class="lingshou-item"
            v-for="(one, o_index) in bf['images']"
            :key="o_index"
          >
            <img
              :src="cbg_img(`/holybeast/fourbook/${bf['type']}/${one['icon']}`)"
            />

            <div
              class="lingshou-desc StarTable"
              tooltip_title="#c1D9BCE{{one['name'] or ''}}"
              tooltip_intro="{{one['tip'] or ''}}"
              v-if="one.tip"
            ></div>
          </a>

          <img
            :src="
              cbg_img(
                `/holybeast/fourbook/${bf['type']}/${bf['type']}shen-00.png`
              )
            "
            class="lingshou-img-map"
          />
          <img
            :src="
              cbg_img(
                `/holybeast/fourbook/${bf['type']}/${bf['type']}shen-01.png`
              )
            "
            class="lingshou-img-map"
            usemap="#lingshou_map_{{bf['type']}}"
          />
        </div> -->
      </tx-bg>
    </tx-bg>
  </div>

  <div class="rEmpty" v-else>
    <div>该角色尚未获得灵兽</div>
  </div>
  <!-- </div> -->
</template>

<script setup>
import { defineProps, ref, computed, inject } from 'vue';
const { cbg_img } = inject('filters');

const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

const cur_key = ref(0);

const beast_star_names = ref([
  '太阳',
  '太阴',
  '晨星',
  '太白',
  '荧惑',
  '岁星',
  '镇星',
]);

const margin1 = ref([
  { text: '等级', key: 'lv' },
  { text: '经验', key: 'exp' },
  { text: '成长值', key: 'pullulate' },
]);

const margin2 = ref([
  { text: '力', key: 'str' },
  { text: '体', key: 'con' },
  { text: '敏', key: 'dex' },
  { text: '疾', key: 'dog' },
  { text: '魂', key: 'int' },
  { text: '念', key: 'mind' },
]);

const margin3 = ref([
  { text: '潜能', key: 'potential' },
  { text: '总资质', key: 'a_total' },
]);

const beasts = computed(() => {
  return props.role_data?.beasts || [];
});

const beast = computed(() => {
  return beasts.value[cur_key.value] || {};
});

const beasts_equ = computed(() => {
  return props.role_data?.beasts_equ || [];
});

const beasts_fourbooks = computed(() => {
  return props.role_data?.beasts_fourbooks || {};
});

const bf = computed(() => {
  return beasts_fourbooks.value[beast.value.id];
});
</script>

<style lang="scss" scoped>
.tableLS {
  display: flex;
  justify-content: space-between;
}

.TableContents {
  display: flex;
  justify-content: space-between;
}

.margin-item {
  display: flex;
  justify-content: space-between;
}
</style>